/**
 * 🛰️ 福氣好門 GIS | 組件基底類別 (SovereignCabinet v15.2.0)
 * 職責：作為所有「功能組裝櫃」的物理模板，提供生命週期管理與 Shadow DOM 隔離。
 */

import { bus as globalBus } from './sovereign-bus.js';

export class SovereignCabinet extends HTMLElement {
    constructor() {
        super();
        this.bus = window.SovereignBus || globalBus;
        this.attachShadow({ mode: 'open' }); // 開啟物理級別的樣式隔離
    }

    /**
     * 當櫃子被「插上」頁面時觸發
     */
    connectedCallback() {
        console.log(`[Cabinet] {${this.tagName}} 物理掛載成功。`);
        this._isConnected = true;
        
        // 若沒有調用非同步 loadAssets（且已設定模板），直接觸發 onMount
        if (!this._isLoadingAssets && this.shadowRoot.innerHTML !== '') {
            this.onMount();
        }
    }

    /**
     * 當櫃子被「拔除」時觸發 (防止記憶體洩漏與殘留)
     */
    disconnectedCallback() {
        console.log(`[Cabinet] {${this.tagName}} 已物理撤除。`);
        this.onUnmount();
    }

    /**
     * 子類別重寫：掛載後的邏輯
     */
    onMount() {}

    /**
     * 子類別重寫：卸載前的清理
     */
    onUnmount() {}

    /**
     * 快捷發布訊息至匯流排
     */
    emit(event, data) {
        this.bus.emit(`${this.tagName.toLowerCase()}:${event}`, data);
    }

    /**
     * 渲染 HTML/CSS 到 Shadow DOM
     */
    setTemplate(html, css = '') {
        const style = css ? `<style>${css}</style>` : '';
        this.shadowRoot.innerHTML = `${style}${html}`;
    }

    /**
     * 動態加載同目錄下的 template.html 與 style.css 以落實資料夾集成
     * @param {string} dirPath - 例如 '/js/cabinets/bus'
     */
    async loadAssets(dirPath) {
        this._isLoadingAssets = true;
        try {
            const v = Date.now();
            const [htmlRes, cssRes] = await Promise.all([
                fetch(`${dirPath}/template.html?v=${v}`),
                fetch(`${dirPath}/style.css?v=${v}`)
            ]);
            const html = htmlRes.ok ? await htmlRes.text() : '';
            const css = cssRes.ok ? await cssRes.text() : '';
            // 空 HTML 不覆蓋既有後備模板（截圖柜等）
            if (html && html.trim()) {
                this.setTemplate(html, css);
            } else if (!this.shadowRoot?.innerHTML?.trim()) {
                console.warn(`[Cabinet] ${this.tagName} template empty from ${dirPath}`);
            }
            
            this._isLoadingAssets = false;
            // 如果此時已經 attach 到 DOM 上，就觸發 onMount
            if (this._isConnected) {
                this.onMount();
                if (typeof this.afterAssetsMounted === 'function') {
                    this.afterAssetsMounted();
                }
            }
        } catch (e) {
            console.error(`[Cabinet] ${this.tagName} failed to load assets from ${dirPath}`, e);
            this._isLoadingAssets = false;
            if (this._isConnected) {
                try { this.onMount(); } catch (_) { /* ignore */ }
            }
        }
    }
}

// 供全域模組引用
window.SovereignCabinet = SovereignCabinet;
